module.exports = __webpack_public_path__ + "static/media/logo.64bb5a6a.png";